import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-add-animal-disease',
  templateUrl: './add-animal-disease.component.html',
  styleUrls: ['./add-animal-disease.component.css']
})
export class AddAnimalDiseaseComponent implements OnInit {


  animal_disease: FormGroup;


  returnUrl = "/dashboard/RottweilerDogsAnimalmanagement";
  addDiseaseFormValue: any;
  addUrl: any;
  route: any;
  getlistApi: any;
  getDiseaseListData: any
  fragment: any;
  loginresponse: any;
  cby_mby: any;

  disease_name: any;
  drug_name: any;
  dose_value: any;
  units: any;
  date_of_discovery: any;
  treatment_given: any;

  error_flag: boolean = false;



  constructor(private router: Router, private commonService: CommonService, private formbuilder: FormBuilder) {

    this.animal_disease = this.formbuilder.group({

      disease_name: ['', Validators.required],
      drug_name: ['', Validators.required],
      dose_value: ['', Validators.required],
      units: ['', Validators.required],
      date_of_discovery: ['', Validators.required],
      treatment_given: ['', Validators.required],

    })


  }

  async ngOnInit() {
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby = this.loginresponse.user_id;
    $('.selectpicker').selectpicker('refresh');
    this.getlistApi = "/disease";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async (res) => {
        this.getDiseaseListData = res.data;
      })
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 1000);
    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });

  }

  async AnimalDisease() {

    if (!this.disease_name || !this.drug_name || !this.dose_value || !this.units || !this.date_of_discovery || !this.treatment_given) {

      if (!this.disease_name) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.drug_name) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.dose_value) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.units) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.date_of_discovery) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.treatment_given) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }

      return;
      
    }

    var farmid = sessionStorage.getItem('farmid');
    var Animalid = sessionStorage.getItem('animalid');
    var speciesid = sessionStorage.getItem('speciesid');
    var breedid = sessionStorage.getItem('breedid');
    var ageid = sessionStorage.getItem('ageid');
    this.addDiseaseFormValue = {
      "species_id": speciesid,
      "breed_id": breedid,
      "farm_id": farmid,
      "animal_code": Animalid,
      "drug_name": $("#drugname").val(),
      "dose_value": $("#dosevalue").val(),
      "units": $("#unit").val(),
      "disease_name": $("#diseasename").val(),
      "treatment_given": $("#TreatmentDate").val(),
      "age_group": ageid,
      "disease_description": $("#Description").val(),
      "date_of_discovery": $("#DiscoveryDate").val(),
      "cby": this.cby_mby,
      "status": 1,
      "is_active": 1
    };
    console.log(this.addDiseaseFormValue)
    this.addUrl = "/animal_management/disease";
    (await this.commonService.postApi(this.addUrl, this.addDiseaseFormValue)).subscribe(
      data => {
        alert("Data added successfully");
      });
    setTimeout(
      (): void => {

        this.router.navigate([this.returnUrl, { fragment: 'Disease' }]);

      },
      500
    );
    //}
  }

  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }
}
